module.exports = __webpack_public_path__ + "static/media/Simulator Screen Recording - iPhone 17 Pro - 2026-03-17 at 08.27.01.f78986be.mov";